/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  queryTurbineInspections,
  queryInspectionModels,
} from "src/services/AmplifyQuery";

import PrintReport from "src/views/print/Result.react";
/**
 * The Inspection Page component
 *
 * @author Thais Watanabe
 */
const Inspection = () => {
  const location = useLocation();

  const { inspection, lastInspectionsIds } = location.state;

  const [turbineInspections, setTurbineInspections] = useState([]);
  const [lastTurbineInspections, setLastTurbineInspections] = useState([]);
  const [inspectionModels, setInspectionModels] = useState(null);

  /**
   * useEffect
   */
  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0);
  }, []);

  /**
   * useEffect
   */
  useEffect(() => {
    fetchTurbineInspections();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * fetchTurbineInspections
   */
  async function fetchTurbineInspections() {
    const filter = { inspectionID: { eq: inspection.id } };

    queryTurbineInspections(filter, null, [], setTurbineInspections);
  }

  /* useEffect */
  useEffect(() => {
    fetchInspectionModels();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * fetchInspectionModelItems
   */
  async function fetchInspectionModels() {
    queryInspectionModels(null, setInspectionModels);
  }
  /**
   * useEffect
   */
  useEffect(() => {
    fetchLastTurbineInspections();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * findLastInspectionTurbines
   * @param {*} windTurbineId
   * @returns
   */
  function findLastInspectionTurbines(windTurbineId) {
    return lastTurbineInspections
      .filter((obj) => obj.windTurbineID === windTurbineId)
      .sort((a, b) => (a.date > b.date ? 1 : -1));
    // .map((obj) => obj.id);
  }

  /**
   * fetchTurbineInspections
   */
  async function fetchLastTurbineInspections() {
    const inspectionIds = lastInspectionsIds.filter((item) => item);

    if (inspectionIds.length > 0) {
      const filter = { or: [] };

      inspectionIds.forEach((id) =>
        filter.or.push({ inspectionID: { eq: id } })
      );

      queryTurbineInspections(filter, null, [], setLastTurbineInspections);
    }
  }

  return (
    <div>
      {turbineInspections
        .sort((a, b) =>
          a["name"].localeCompare(b["name"], undefined, {
            numeric: true,
            sensitivity: "base",
          })
        )
        .map((turbineInspection, i) => (
          <div key={i}>
            <PrintReport
              inspection={inspection}
              turbineInspection={turbineInspection}
              lastTurbineInspections={findLastInspectionTurbines(
                turbineInspection.windTurbineID
              )}
              inspectionModels={inspectionModels}
            />
          </div>
        ))}
    </div>
  );
};

export default Inspection;
